import type { ReactNode } from 'react'
import { cn } from '@sunwebgroup/uds-ui/utils'
import styles from './WeatherGraph.module.css'

interface WeatherGraphProps {
  ariaLabel?: string
  children: ReactNode
}

interface WeatherGraphHeadingProps {
  className?: string
  children: ReactNode
}

interface WeatherGraphColumnProps {
  className?: string
  children: ReactNode
}

interface WeatherGraphColumnHeadingProps {
  className?: string
  children: ReactNode
}

export function WeatherGraph({ ariaLabel, children }: WeatherGraphProps) {
  return (
    <div className={styles.root} role={ariaLabel ? 'region' : undefined} aria-label={ariaLabel}>
      {children}
    </div>
  )
}

export function WeatherGraphHeading({ className, children }: WeatherGraphHeadingProps) {
  return <div className={cn(styles.heading, className)}>{children}</div>
}

export function WeatherGraphColumn({ className, children }: WeatherGraphColumnProps) {
  return (
    <div className={cn(styles.column, className)}>
      {children}
    </div>
  )
}

export function WeatherGraphColumnHeading({ className, children }: WeatherGraphColumnHeadingProps) {
  return <div className={cn(styles.columnHeading, className)}>{children}</div>
}
